import React, { useEffect, useState } from "react";

export type ImageResult = {
  result?: string[];
  isLoading: boolean;
};

export default function usePhotoLibrary(): [
  ImageResult,
  (maxCount?: number) => void
] {
  const [result, setResult] = React.useState<ImageResult>({
    isLoading: true,
  });
  const [photoUrls, setPhotoUrls] = useState<string[]>([]);

  const callPhotoLibrary = function (maxCount = 1) {
    setResult((prev) => ({ ...prev, isLoading: true }));
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.photoLibrary) {
        // setLog("android available");
        window.SANDI.photoLibrary(maxCount);
      } else {
        // setLog("android not available");
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      // setLog("ios called" + JSON.stringify(window.webkit));
      window.webkit?.messageHandlers.photoLibrary.postMessage(
        maxCount.toString()
      );
    } else {
      //아이폰, 안드로이드 외
      return "other";
    }
  };

  const handlePhotoLibrary = function (urls: string[]) {
    // setLog(
    //   "====================handlePhotoLibrary:::::::urls=" +
    //     typeof urls +
    //     urls?.length
    // );
    setResult({
      result: urls.map((url: any) => url.replace(/-/g, "/")),
      isLoading: false,
    });
  };

  // android에서 다건의 이미지 송신 시, 길이 제한으로 실패하는 문제로 여러장을 단건으로 수신받는 기능 추가
  // 취소의 경우 handlePhotoLibrary에 빈 배열을 넘기기로 함
  const handlePhoto = function (index: number, maxCount: number, url: string) {
    // 최대 사이즈와 photoUrls 저장 공간의 길이가 다를 경우 photoUrls를 최대 사이즈로 맞춰줌
    // console.log(`photo ${index}/${maxCount}`);
    if (photoUrls.length !== maxCount) {
      setPhotoUrls((prev) =>
        prev.length !== maxCount ? Array(maxCount).fill("") : prev
      );
      // console.log(`resize photoUrls ${photoUrls.length} => ${maxCount}`);
    }
    setPhotoUrls((prev) =>
      prev.map((prevUrl, i) => (i === index ? url : prevUrl))
    );
  };

  useEffect(() => {
    // console.log(
    //   `update photoUrls ${photoUrls.filter((url) => url.length > 0).length}/${
    //     photoUrls.length
    //   }`
    // );
    if (photoUrls.length > 0 && photoUrls.every((url) => url.length > 0)) {
      // console.log("received all photos");
      setResult({
        result: photoUrls.map((url: any) => url.replace(/-/g, "/")),
        isLoading: false,
      });
    }
  }, [photoUrls]);

  useEffect(() => {
    if (result.isLoading === false) {
      setPhotoUrls([]);
    }
  }, [result]);

  useEffect(() => {
    window.handlePhotoLibrary = handlePhotoLibrary;
    // android에서 다건의 이미지 송신 시, 길이 제한으로 실패하는 문제로 여러장을 단건으로 수신받는 기능 추가
    window.handlePhoto = handlePhoto;
  }, []);

  return [result, callPhotoLibrary];
}
